import { densityPx } from '@/theme/base/density'

/** Largeur drawer étendu (référence design × densité). */
const SIDE_NAV_EXPANDED_DESIGN_PX = 270

/** Largeur drawer replié. */
const SIDE_NAV_FOLDED_DESIGN_PX = 70

export const SIDE_NAV_DRAWER_EXPANDED_PX = densityPx(
  SIDE_NAV_EXPANDED_DESIGN_PX
)

export const SIDE_NAV_DRAWER_FOLDED_PX = densityPx(SIDE_NAV_FOLDED_DESIGN_PX)

/** Taille police items nav : référence design 14px − 1px, avec densité. */
export const SIDE_NAV_ITEM_FONT_SIZE = `${densityPx(14) - 1}px`

/** Taille police sous-items nav : référence design 13px − 1px, avec densité. */
export const SIDE_NAV_SUB_ITEM_FONT_SIZE = `${densityPx(13) - 1}px`

/** Titre de section nav (−1px). */
export const SIDE_NAV_SECTION_TITLE_FONT_SIZE = 11

/** Décalage des popovers sidenav pour ne pas recouvrir le bord du drawer. */
export const SIDE_NAV_POPOVER_OFFSET_PX = densityPx(28)

export const sideNavPopoverBackdropSx = {
  backgroundColor: 'rgba(15, 23, 42, 0.28)',
}

export const sideNavPopoverPaperShadow =
  '0 10px 28px rgba(15, 23, 42, 0.22)'

/** Hover des boutons sidenav (hors User) : fond + typo / icône en blanc. */
export const sideNavButtonHoverSx = {
  backgroundColor: 'var(--nav-item-hover-bg)',
  '& .MuiTypography-root': {
    color: 'var(--nav-item-active-color)',
  },
  '& .MuiSvgIcon-root': {
    color: 'var(--nav-item-active-color)',
  },
  '& > span:first-of-type': {
    color: 'var(--nav-item-active-color)',
  },
}

/** Item déjà actif : le fond teal est juste un peu plus soutenu, icône inchangée. */
export const sideNavActiveButtonHoverSx = {
  backgroundColor: 'var(--nav-item-active-hover-bg)',
}
